module.exports = __webpack_public_path__ + "img/node-minus.216a25c7.svg";